import { TuitionFeeDebt } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    studentDebts: [],
    count: 0,
    totalAmountDebt: 0,
    totalAmountPaid: 0,
    query: [],
    loading: false,
  },
  actions: {
    async fetchStudentDebt({ commit }, params) {
      const studentDebts = await TuitionFeeDebt.fetch(params)
      commit('setStudentDebts', studentDebts)
    },
    async countStudentDebt({ commit }, params) {
      const count = await TuitionFeeDebt.count(params)
      commit('setCount', count)
    },
    async getStats({ commit }, params) {
      const data = await TuitionFeeDebt.getStats(params)
      commit('setTotalAmountDebt', data[0].totalAmountDebt)
    },
  },
  mutations: {
    setStudentDebts(state, data) {
      state.studentDebts = data
    },
    setCount(state, data) {
      state.count = data
    },
    setTotalAmountDebt(state, data) {
      state.totalAmountDebt = data
    },
    setTotalAmountPaid(state, data) {
      state.totalAmountPaid = data
    },
    setQuery(state, query) {
      state.query = query
    },
    setLoading(state, value) {
      state.loading = value
    },
  },
  getters: {
    getStudentDebts: state => state.studentDebts,
    count: state => state.count,
    getQuery: state => state.query,
    loading: state => state.loading,
    totalAmountDebt: state => state.totalAmountDebt,
    totalAmountPaid: state => state.totalAmountPaid,
  },
}
